import {Pipe, PipeTransform} from '@angular/core';

declare let numeral: any;

@Pipe({name: 'numeral'})
export class NumeralPipe implements PipeTransform {
   transform(value: number, format?: string): string {
      return numeral(value).format(format || '0,0');
   }
}
